"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.FILE_REFERENCES, (table)=>{
        table.string('id', 20).primary().notNullable();
        table.string('storage');
        table.text('file_url');
        table.integer('file_size');
        table.string('fk_user_id', 20);
        table.string('fk_workspace_id', 20);
        table.string('base_id', 20);
        table.string('source_id', 20);
        table.string('fk_model_id', 20);
        table.string('fk_column_id', 20);
        table.boolean('is_external').defaultTo(false);
        table.boolean('deleted').defaultTo(false);
        table.timestamps(true, true);
        // this index is used on migration, this can be removed after migration
        if (!knex.client.config.client.includes('mysql')) {
            table.index([
                'file_url',
                'storage'
            ], 'nc_file_references_temp');
        }
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.FILE_REFERENCES);
};
